  document.getElementById('year').textContent = new Date().getFullYear();

  function setLang(lang, btn){
    document.body.classList.toggle('sv', lang === 'sv');
    document.querySelectorAll('.lang-toggle button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  /* ===== Preloader ===== */
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.getElementById('preloader').classList.add('done');
    }, 1400);
  });

  /* ===== Custom cursor (dot + ring) + glow ===== */
  (function() {
    if (matchMedia('(pointer: coarse)').matches) {
      document.getElementById('cursorDot')?.remove();
      document.getElementById('cursorRing')?.remove();
      return;
    }
    const dot = document.getElementById('cursorDot');
    const ring = document.getElementById('cursorRing');
    const glow = document.getElementById('cursorGlow');
    let tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    let dx = tx, dy = ty, rx = tx, ry = ty, gx = tx, gy = ty;
    document.addEventListener('mousemove', (e) => {
      tx = e.clientX; ty = e.clientY;
      document.body.classList.add('cursor-active');
    });
    document.addEventListener('mouseleave', () => document.body.classList.remove('cursor-active'));

    // Hover detection
    document.querySelectorAll('a, button, .interest-option, .product, .division, input, select, textarea').forEach(el => {
      el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
    });

    function animate() {
      // Dot follows almost instantly
      dx += (tx - dx) * 0.7;
      dy += (ty - dy) * 0.7;
      // Ring lags behind for smooth trail
      rx += (tx - rx) * 0.18;
      ry += (ty - ry) * 0.18;
      // Glow lags more
      gx += (tx - gx) * 0.10;
      gy += (ty - gy) * 0.10;
      if (dot) dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%, -50%)`;
      if (ring) ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      if (glow) glow.style.transform = `translate(${gx}px, ${gy}px) translate(-50%, -50%)`;
      requestAnimationFrame(animate);
    }
    animate();
  })();

  /* ===== Reading progress bar ===== */
  (function() {
    const bar = document.getElementById('progressBar');
    if (!bar) return;
    function update() {
      const scroll = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const pct = height > 0 ? (scroll / height) * 100 : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  /* ===== Section nav active state ===== */
  (function() {
    const links = document.querySelectorAll('.section-nav a');
    if (!links.length) return;
    const sections = Array.from(links).map(a => document.getElementById(a.dataset.section)).filter(Boolean);
    function update() {
      const scrollY = window.scrollY + 200;
      let active = sections[0]?.id;
      sections.forEach(s => { if (s.offsetTop <= scrollY) active = s.id; });
      links.forEach(a => a.classList.toggle('active', a.dataset.section === active));
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  /* ===== Magnetic buttons ===== */
  (function() {
    if (matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.btn-gold, .header-cta, .division-link').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.25}px, ${y * 0.3}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  })();

  /* ===== 3D tilt on cards ===== */
  (function() {
    if (matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.division, .product').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `perspective(1000px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-6px)`;
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  })();

  /* ===== Smooth scroll for anchor links ===== */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href');
      if (id === '#' || id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      window.scrollTo({
        top: target.offsetTop - 80,
        behavior: 'smooth'
      });
    });
  });

  /* ===== FAQ accordion ===== */
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ===== Multi-step wizard ===== */
  (function() {
    const form = document.getElementById('wizardForm');
    if (!form) return;
    let selectedInterest = null;

    // Interest selection
    form.querySelectorAll('.interest-option').forEach(opt => {
      opt.addEventListener('click', () => {
        form.querySelectorAll('.interest-option').forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');
        selectedInterest = opt.dataset.value;
      });
    });

    // Next/Prev
    function goTo(step) {
      form.querySelectorAll('.wizard-pane').forEach(p => p.classList.remove('active'));
      form.querySelector(`.wizard-pane[data-pane="${step}"]`).classList.add('active');
      form.querySelectorAll('.wizard-step').forEach(s => {
        const n = parseInt(s.dataset.step);
        s.classList.toggle('active', n === step);
        s.classList.toggle('done', n < step);
      });
    }

    form.querySelectorAll('[data-next]').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.next);
        // Validate step 1
        if (step === 2 && !selectedInterest) {
          alert(document.body.classList.contains('sv')
            ? 'Välj ett alternativ för att fortsätta'
            : 'Please choose an option to continue');
          return;
        }
        // Validate step 2 fields
        if (step === 3) {
          const pane = form.querySelector('.wizard-pane[data-pane="2"]');
          const fields = pane.querySelectorAll('input[required]');
          for (const f of fields) {
            if (!f.checkValidity()) { f.reportValidity(); return; }
          }
        }
        goTo(step);
      });
    });
    form.querySelectorAll('[data-prev]').forEach(btn => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.prev)));
    });
  })();

  /* ===== Gold dividers reveal on scroll ===== */
  (function() {
    const divs = document.querySelectorAll('.gold-divider');
    if (!divs.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    divs.forEach(d => io.observe(d));
  })();

  /* ===== Scroll reveal — auto-tag elements ===== */
  ['.section-head', '.division', '.product', '.testimonial', '.step', '.feature', '.story-visual', '.story > div:last-child', '.cta-block .container', '.contact-info', 'form.quote', '.shop-head'].forEach(sel => {
    document.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('reveal');
      el.style.transitionDelay = `${(i % 4) * 80}ms`;
    });
  });

  (function() {
    const revealEls = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(el => io.observe(el));
  })();

  /* ===== Stats count-up ===== */
  (function() {
    const nums = document.querySelectorAll('.stat .num');
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = el.textContent.trim();
        const isNumeric = /^\d+$/.test(target);
        if (isNumeric) {
          const finalVal = parseInt(target, 10);
          let current = 0;
          const duration = 1200;
          const start = performance.now();
          function step(now) {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            current = Math.floor(eased * finalVal);
            el.textContent = current;
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = finalVal;
          }
          requestAnimationFrame(step);
        }
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    nums.forEach(el => io.observe(el));
  })();

  /* ===== Shop filters (visual demo) ===== */
  document.querySelectorAll('.shop-filter').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.shop-filter').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
